import React, {Component} from 'react'

import reactSelect from './react-select.min.css'

import {Select, VirtualizedSelect} from 'bsui'

import './styles.less'

export default class MultiSelect extends Component {
    render() {
        let {value, onChange, name, ...props} = this.props
        let values = value.values

        return (
            <div ref={(select) => this.m_select = select}>
                <div>
                    <VirtualizedSelect
                        wide
                        className="multi-select__virtualized"
                        placeholder="Выберите..."
                        multi={true}
                        joinValues={true}
                        value={values}
                        name={name}
                        onChange={(options) => {
                            this.m_select.name = name
                            this.m_select.value = {
                                values: options.map(item => item.value)
                            }
                            let event = $.Event('change', {target: this.m_select})
                            if (onChange) {
                                onChange(event)
                            }
                        }}
                        {...props}
                    />
                </div>
            </div>
        )
    }
}